/**
 * The formatter an artifact renderer needs. Total by design: a card must never
 * disappear because a string would not parse.
 *
 * `formatDuration` used to live here as spine for Spec I's video card. It was
 * deleted with the card's duration badge on 2026-08-08 — `duration_seconds` is
 * gone from the payload and `extra="forbid"` rejects it, so nothing could ever
 * call it. Do not restore it without restoring the field first.
 */
import { format, parseISO } from 'date-fns'

/**
 * "2026-08-03" -> "Mon 3 Aug". Returns the input unchanged when it will not
 * parse — `parseISO` yields an Invalid Date rather than throwing, and `format`
 * throws on one, which would take the whole message down.
 */
export function formatArtifactDate(iso: string): string {
  try {
    const parsed = parseISO(iso)
    if (Number.isNaN(parsed.getTime())) return iso
    return format(parsed, 'EEE d MMM')
  } catch {
    return iso
  }
}
